import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CreateTestCaseLinkRequest, TestCaseLink } from '../models/test-case-link.model';

@Injectable({ providedIn: 'root' })
export class TestCaseLinksService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiBaseUrl}/api/v1/projects`;

  private linksUrl(projectId: string, testCaseId: string): string {
    return `${this.baseUrl}/${projectId}/test-cases/${testCaseId}/links`;
  }

  list(projectId: string, testCaseId: string): Observable<TestCaseLink[]> {
    return this.http.get<TestCaseLink[]>(this.linksUrl(projectId, testCaseId));
  }

  create(projectId: string, testCaseId: string, request: CreateTestCaseLinkRequest): Observable<TestCaseLink> {
    return this.http.post<TestCaseLink>(this.linksUrl(projectId, testCaseId), request);
  }

  delete(projectId: string, testCaseId: string, linkId: string): Observable<void> {
    return this.http.delete<void>(`${this.linksUrl(projectId, testCaseId)}/${linkId}`);
  }
}
